import { render, staticRenderFns } from "./MoreHoursCategoriesDialog.vue?vue&type=template&id=052d5ece&scoped=true&"
import script from "./MoreHoursCategoriesDialog.vue?vue&type=script&lang=js&"
export * from "./MoreHoursCategoriesDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoreHoursCategoriesDialog.vue?vue&type=style&index=0&id=052d5ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d5ece",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VIcon,VList,VListItem,VListItemContent,VVirtualScroll})
